import { SECTION_ITEM_TYPE } from "@constants";
import { editingCourseActions, updateLectureAction } from "@redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";

const useCurriculum = () => {
  const dispatch = useDispatch();
  const sections = useSelector((state) => state.course.editingCourse.sections);

  const handleChangeOrderUnits = (sectionId, newListItem) => {
    const newUnits = [...newListItem].map((item) => ({
      ...item,
      chosen: false,
    }));

    dispatch(editingCourseActions.changeOrderUnits({ sectionId, newUnits }));
  };

  const handleChangeSectionTitle = (sectionId, newTitle) => {
    dispatch(editingCourseActions.changeSectionTitle({ sectionId, newTitle }));
  };

  const handleAddLecture = (sectionId, newLecture) => {
    const newItem = {
      ...newLecture,
      id: uuidv4(),
      type: SECTION_ITEM_TYPE.LECTURE,
    };
    dispatch(editingCourseActions.addLecture({ sectionId, newItem }));
  };

  const handleEditLecture = (sectionId, newItem) => {
    dispatch(updateLectureAction({ sectionId, newItem }));
  };

  const handleDeleteLecture = (sectionId, lectureId) => {
    dispatch(editingCourseActions.deleteLecture({ sectionId, lectureId }));
  };

  const handleAddSection = (title) => {
    dispatch(
      editingCourseActions.addSection({
        id: uuidv4(),
        title: title,
        lectures: [],
        quizzes: [],
        assignments: [],
        units: [],
        isNew: true,
      })
    );
  };

  const handleAddQuiz = (sectionId, newQuiz) => {
    const quiz = { ...newQuiz, id: uuidv4(), type: SECTION_ITEM_TYPE.QUIZ };
    dispatch(editingCourseActions.addQuiz({ sectionId, quiz }));
  };

  const handleDeleteQuiz = (sectionId, quizId) => {
    dispatch(editingCourseActions.deleteQuiz({ sectionId, quizId }));
  };

  const handleEditQuiz = (sectionId, newQuiz) => {
    dispatch(editingCourseActions.editQuiz({ sectionId, newQuiz }));
  };

  const handleDeleteSection = (sectionId) => {
    dispatch(editingCourseActions.deleteSection({ sectionId }));
  };

  const handleAddAssignment = (sectionId, newAssignment) => {
    const assignment = {
      ...newAssignment,
      id: uuidv4(),
      type: SECTION_ITEM_TYPE.ASSIGNMENT,
    };
    dispatch(editingCourseActions.addAssignment({ sectionId, assignment }));
  };

  const handleDeleteAssignment = (sectionId, assignmentId) => {
    dispatch(
      editingCourseActions.deleteAssignment({ sectionId, assignmentId })
    );
  };

  const handleEditAssignment = (sectionId, newAssignment) => {
    console.log(newAssignment);
    dispatch(editingCourseActions.editAssignment({ sectionId, newAssignment }));
  };

  return {
    sections,
    handleChangeOrderUnits,
    handleChangeSectionTitle,
    handleAddLecture,
    handleDeleteLecture,
    handleAddSection,
    handleEditLecture,
    handleDeleteSection,
    handleAddQuiz,
    handleDeleteQuiz,
    handleEditQuiz,
    handleAddAssignment,
    handleDeleteAssignment,
    handleEditAssignment,
  };
};

/* required: display name */
useCurriculum.displayName = "useCurriculum";

/* required: props types */
useCurriculum.propTypes = {};

/* required: default props */
useCurriculum.defaultProps = {};

export { useCurriculum };
